import Icon from "@/components/icons/Icons";
import React from "react";

export default function ToolTipButton({
  content,
  side = "left",
  className = "",
  toolTipIconColor = "sm:hover:text-black/40",
}: {
  content: string | number;
  side?: "top" | "left" | "right";
  className?: string;
  toolTipIconColor?: string;
}) {
  return (
    <div className="relative inline-block group">
      <Icon.infoIcon className={["w-5 h-5 transition cursor-pointer rotate-180", toolTipIconColor].join(" ")} />

      <div
        className={`absolute transition duration-200 group-hover:scale-100 text-white text-[10px] xxs:text-xs bg-primaryBlack pointer-events-none px-3 py-2 rounded-sm ${side === "left" ? "left-full top-1/2 ml-2 -translate-y-1/2 scale-0 xxs:whitespace-nowrap z-50 w-35 xxs:w-fit" : side === "right" ? "right-full top-1/2 mr-2 -translate-y-1/2 scale-0 xxs:whitespace-nowrap z-50 w-35 xxs:w-fit" : "bottom-full mb-3 left-1/2 -translate-x-1/2 opacity-0 scale-95 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 z-50 max-w-[90vw] sm:max-w-xs w-80"} ${className}`}
      >
        <div dangerouslySetInnerHTML={{ __html: String(content) }} />

        {side === "left" ? (
          <div className="absolute -left-1.5 top-1/2 -translate-y-1/2 w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-r-[6px] border-r-[#222]" />
        ) : side === "right" ? (
          <div className="absolute -right-1.5 top-1/2 -translate-y-1/2 w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-l-[6px] border-l-[#222]" />
        ) : (
          <div className="absolute left-1/2 -bottom-2 -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-black" />
        )}
      </div>
    </div>
  );
}
